import React, { useEffect } from 'react';

import type { ExtendedBrightcovePlayer } from '../../types';

import { getVolumeLevel } from './getVolumeLevel';
import { VOLUME_CONTROL_CLASS_NAME, VOLUME_TOOLTIP_CLASS_NAME } from '../../brightcove-constants';
import { useMediaPlayer } from '../../MediaPlayerProvider';

function registerEventListener(player: ExtendedBrightcovePlayer): void {
  const clickHandler = () => {
    const tooltipCtl = document.querySelector(`.${VOLUME_TOOLTIP_CLASS_NAME}`);
    if (tooltipCtl !== null) {
      const volumeLevel = getVolumeLevel(tooltipCtl?.textContent ?? '');
      if (volumeLevel >= 0) {
        player.volume(volumeLevel);
      }
    }
  };

  const volumeControl = document.querySelector(`.${VOLUME_CONTROL_CLASS_NAME}`);
  if (volumeControl !== null) {
    volumeControl.addEventListener('click', clickHandler);
    player.on('dispose', () => {
      volumeControl.removeEventListener('click', clickHandler);
    });
  }
}

export const AdjustVolumeByClick: React.FC = () => {
  const { player } = useMediaPlayer();
  useEffect(() => {
    if (player !== null) {
      registerEventListener(player);
    }
  }, [player]);
  return null;
};
